module.exports = __webpack_public_path__ + "img/worksbot_img20021112.e04eed46.jpg";